<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>SIMs</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              :items="renderedDepots"
              item-text="name"
              item-value="id"
              return-object
              v-model="depot"
              clearable
              prepend-icon="fas fa-map"
              label="Depot...">
            </v-select>
          </v-col>
          <v-col v-show="admin" cols="12" md="3">
            <v-file-input
              v-model="excelFile"
              label="SIMs input"
              hint="select a .xlsx file"
              accept=".xlsx"
              @click:clear="resetData"
            ></v-file-input>
          </v-col>
          <v-col v-show="admin" cols="12" md="2">
            <v-btn
              :disabled="!excelFile"
              color="primary"
              class="ma-2 white--text"
              @click="readXLSX"
            >
              <v-icon dark>fas fa-file-import</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="renderedSims"
        :search="search"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: center"
                v-for="(header, index) in headers"
                v-if="header.text !== 'Actions'"
                @click="rowSelected(props.item)"
                :key="index">{{props.item[header.value]}}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <transition name="scale-transition">
      <v-dialog v-model="editDialog" v-if="displayedItem" width="800px">
        <v-card>
          <v-card-title class="d-flex" style="position: relative"
                        :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
            <h2>SIM {{displayedItem.id}}</h2>
            <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="editDialog=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row justify="space-around">
              <v-col cols="12" class="text-center justify-space-between">
                <v-tooltip top color="secondary" v-if="admin && displayedItem.type === 2">
                  <template v-slot:activator="{ on }">
                    <v-icon color="blue" @click="resetSIM(displayedItem)" v-on="on" class="pl-1">
                      sync
                    </v-icon>
                  </template>
                  <span>Reset SIM</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row justify="space-around">
              <v-list two-line>
                <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                  <v-col cols="12" md="6" v-for="(key, index) in Object.keys(displayedItem)" :key="index">
                    <v-list-item>
                      <v-list-item-action>
                        <div>
                          <v-icon color="blue darken-1">{{icons[key]}}</v-icon>
                        </div>
                      </v-list-item-action>
                      <v-list-item-content>
                        <div v-if="!fab">
                          <v-list-item-title>{{capitalizeFirstLetter(key)}}</v-list-item-title>

                          <v-tooltip color="secondary" top>
                            <template v-slot:activator="{ on }">
                              <v-list-item-subtitle v-on="on">
                                {{displayedItem[key]}}
                              </v-list-item-subtitle>
                            </template>
                            <span>{{displayedItem[key]}}</span>
                          </v-tooltip>
                        </div>

                        <div v-else>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <div v-if="key === 'depot_id'">
                              <v-select
                                :items="renderedDepots"
                                item-value="id"
                                item-text="name"
                                label="Depot"
                                v-model="editedItem[key]"></v-select>
                            </div>
                            <div v-else>
                              <v-text-field v-model="editedItem[key]"
                                            :label="capitalizeFirstLetter(key)"
                                            :disabled="readOnly.includes(key) || (adminEditabled.includes(key) && !admin)"
                              ></v-text-field>
                            </div>
                          </v-form>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-row>

            <v-row justify="center" align="center">
              <v-col md="2" cols="12" class="text-center">
                <v-btn
                  text
                  @click="editDialog=false;"
                  color="blue-grey lighten-2"
                >Cancel
                </v-btn>
              </v-col>
              <!--              <v-col cols="2" class="text-center">-->
              <!--                <v-btn-->
              <!--                  text-->
              <!--                  @click="saveChanges"-->
              <!--                  color="blue darken-1"-->
              <!--                >Save</v-btn>-->
              <!--              </v-col>-->
            </v-row>

          </v-card-text>
        </v-card>
      </v-dialog>
    </transition>

  </div>
</template>

<script>
    import axios from 'axios';
    import Excel from 'exceljs/dist/exceljs';

    // @vuese
    // For further information on how this page works, have a look at ManagePhonesTable documentation.
    // @group ManageDevices
    export default {
        name: "ManageSimTable",
        data() {
            return {
                dateAddedMenu: false,
                dateRemovedMenu: false,
                valid: false,
                fab: false,
                requiredRule: [
                    v => !!v || 'This field is required.'
                ],
                icons: {
                    id: 'card_travel',
                    depot: 'location_city',
                    model: 'smartphone',
                    scanner_id: 'perm_scan_wifi',
                    last_used: 'watch_later',
                    last_used_by: 'person',
                    phone_id: 'phone_in_talk',
                    phone_number: 'smartphone',
                    number: 'format_list_numbered',
                    phone: 'phone',
                    type:'book',
                    iccid:'format_list_numbered',
                    carrier: 'company'
                },
                readOnly: [
                    "id",
                    "last_used",
                    "last_used_by"
                ],
                adminEditabled: [
                    "depot_id",
                    "number",
                    "phone_number",
                    "phone_id",
                    "scanner_id"
                ],
                search: null,
                allSwitch: true,
                headers: [
                    {text: 'ID', value: 'id', align: 'center', sortable: true},
                    {text: 'ICCID', value: 'iccid', align: 'center', sortable: true},
                    {text: 'Status', value: 'status', align: 'center', sortable: true},
                    {text: 'Phone Number', value: 'phone_number', align: 'center', sortable: false},
                    {text: 'Last used', value: 'last_used', align: 'center', sortable: false},
                    {text: 'Last used by', value: 'last_used_by', align: 'center', sortable: false},
                    {text: 'Phone ID', value: 'phone_id', align: 'center', sortable: false},
                    {text: 'Scanner ID', value: 'scanner_id', align: 'center', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    id: 0,
                    last_used: null,
                    last_used_by: null,
                    phone_id: null,
                    number: null,
                    phone_number: null,
                    scanner_id: null,
                    depot_id: null,
                    type:1,
                    iccid:null,
                    carrier: 'optus'
                },
                defaultSim: {
                    id: 0,
                    last_used: null,
                    last_used_by: null,
                    phone_id: null,
                    number: null,
                    phone_number: null,
                    scanner_id: null,
                    depot_id: null,
                    type:1,
                    iccid:null,
                    carrier: 'optus'
                },
                editDialog: false,
                displayedItem: null,
                depot: null,
                excelFile:null,
                data: [],
                isLoaded: false,
                statPanel: false,
                loading: false,
                idToTableItem: {},
            }
        },
        methods: {
            resetData(){
              this.statPanel = false;
              this.isLoaded = false;
              this.data = [];
            },
            readXLSX(){
              let failureList = [];
              const reader = new FileReader();
              const wb = new Excel.Workbook();
              this.loading = true;
              reader.readAsArrayBuffer(this.excelFile);
              reader.onload = () => {
                const buffer = reader.result;
                wb.xlsx.load(buffer).then(workbook => {
                  workbook.eachSheet((sheet, id) => {
                    sheet.eachRow((row, rowIndex) => {
                      if (rowIndex == 1){
                        row.values.forEach( (item, itemId) => {
                          this.idToTableItem[itemId] = item
                          // console.log(item);
                        });
                      } else {
                        const sim = {};
                        row.values.forEach( (item, itemId) => {
                          if (this.idToTableItem[itemId]){
                            sim[this.idToTableItem[itemId]] = item;
                          }
                        });
                        let body = {
                          depot_id:null,
                          type:2,
                          iccid:sim['ICCID'],
                          number:sim['ICCID'].slice(6),
                          phone_id:null,
                          last_used: null,
                          last_used_by: null,
                          phone_number: sim['MSISDN'],
                          scanner_id: null,
                          carrier: 'optus'
                        };
                        if (sim['Device ID'] !== undefined) body.phone_id = sim['Device ID'];
                        // console.log(body);
                        axios.post(process.env.API_URL + '/sims', body)
                          .then((response) => {
                            this.$store.commit('displaySnackbar', 'New Sim has been created.');
                          })
                          .catch((response) => {
                            failureList.push(body);
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                          });
                        console.log(failureList);
                      }
                    });
                    this.loading = false;
                    this.isLoaded = true;
                  });
                });
              }

            },
            newSim() {
                this.editedIndex = -1;
                this.displayedItem = Object.assign({}, this.defaultSim);
                this.editedItem = Object.assign({}, this.defaultSim);
                this.fab = true;
                this.editDialog = true;
            },
            toggleEdit() {
                this.editedItem = Object.assign({}, this.displayedItem);
            },
            capitalizeFirstLetter(string) {
                string = string.replace(/_/g, ' ');
                return string.charAt(0).toUpperCase() + string.slice(1);
            },

            rowSelected(item) {
                this.displayedItem = Object.assign({}, item);
                delete this.displayedItem['depot_id'];
                this.editedItem = Object.assign({}, this.displayedItem);
                this.editedIndex = this.simItems.indexOf(item);
                this.editDialog = true;
            },
            resetSIM(sim) {
              if (confirm("Are you sure you want to reset SIM status?")) {
                axios.post(process.env.API_URL + '/sims/' + sim.id + '/resetsim', null)
                  .then((response) => {
                    this.$store.commit('displaySnackbar', 'SIM status reset successfully.');
                  })
                  .catch((response) => {
                    this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                  })
              }
            },
            saveChanges() {
                let body = this.editedItem;

                if (this.editedIndex > -1) {
                    axios.put(process.env.API_URL + '/sims/' + body.id, body)
                        .then((response) => {
                            this.displayedItem = Object.assign({}, response.data);
                            Object.assign(this.simItems[this.editedIndex], this.displayedItem);
                            this.$store.commit('displaySnackbar', 'Changes saved.');
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                } else {
                    axios.post(process.env.API_URL + '/sims', body)
                        .then((response) => {
                            this.displayedItem = Object.assign({}, response.data);
                            this.simItems.push(this.displayedItem);
                            this.$store.commit('displaySnackbar', 'SIM created.');
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                }
            }
        },
        computed: {
            admin() {
                return this.$store.getters['auth/hasPermission']('device_admin');
            },
            renderedSims() {
                if (this.simItems == null) {
                    return [];
                }
                return this.simItems;
            },
          renderedDepots() {
            if (this.depots == null) return [];
            this.depots = this.depots.sort(function(a,b){
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
            });
            if (this.admin) {
              let gol = {
                "id": 0,
                "region_id": 0,
                "region_name": "Global",
                "name": "Global",
                "address": "",
                "address2": "",
                "suburb": "",
                "state": "NSW",
                "postcode": "",
                "code": "",
                "wms": false,
                "parent_depot": null,
                "active_phone_cap": "0"
              };
              this.depots.unshift(gol)
            }
            if (this.depots.length > 0) {
              this.depot = this.depots[0];
            }
            return this.depots;
          },
        },
        asyncComputed: {
            async simItems() {
                if (this.depot == null) {
                    return [];
                } else {
                    return await axios.get(process.env.API_URL + '/sims/depots/' + this.depot.id)
                        .then((response) => {
                            return response.data;
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                            return [];
                        })
                }
            },
            async depots() {
              return await axios.get(process.env.API_URL +'/depots')
                .then((response) => {
                  if (response.status === 200) {
                    return response.data;
                  } else {
                    return [];
                  }
                })
                .catch((error) => {
                  return [];
                });

            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/ManageDevices/ManageSimTable.vue